export const getCmsPageRoute = (path: string) => {
    if (path.startsWith('/')) path = path.slice(1)
    return { name: 'page', params: { path: path.split('/') } }
}
